import { render, staticRenderFns } from "./standartBilancoSablonu.vue?vue&type=template&id=15e6bc0a"
import script from "./standartBilancoSablonu.vue?vue&type=script&lang=js"
export * from "./standartBilancoSablonu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports